/**
 * DRIVE COORDINATION (B8): two small facts the card and the drive HUD share.
 *
 *  hold     true while the HUD holds "Arrived at {name}" (2400 ms, §E.6). The
 *           card waits for it before it re-enters, whatever the phase says.
 *  starter  the card's onDrive (the bridge starts choreo.drive). The HUD's
 *           "Resume" uses it when the integrator passes no onResume.
 */
let hold = false;
const subs = new Set<() => void>();
let starter: (() => void) | null = null;

export function setDriveHold(v: boolean): void {
  if (hold === v) return;
  hold = v;
  for (const f of [...subs]) f();
}

export const getDriveHold = (): boolean => hold;

export function subscribeDriveHold(cb: () => void): () => void {
  subs.add(cb);
  return () => {
    subs.delete(cb);
  };
}

export function setDriveStarter(fn: (() => void) | null): void {
  starter = fn;
}

export const getDriveStarter = (): (() => void) | null => starter;
